import { useMemo } from 'react'
import useIsQVariant from './useIsQVariant'

const normalizeHref = (href: any): string => {
  if (typeof href === 'string') return href
  if (href?.pathname) return href.pathname + (href.search || '') + (href.hash || '')
  return String(href || '')
}

const buildHref = (rawHref: any, isQ: boolean): any => {
  const href = normalizeHref(rawHref)

  if (!href) return rawHref

  if (isQ) {
    if (href.startsWith('/auth/signup')) {
      return href.replace('/auth/signup', '/q/auth/signin')
    }

    if (href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:'))
      return rawHref
    if (href.startsWith('/q')) return rawHref
    if (href.startsWith('/_next') || href.startsWith('/api/')) return rawHref

    return `/q${href}`
  }

  return rawHref
}

const useQHref = () => {
  const isQ = useIsQVariant()
  return useMemo(() => ({ buildHref: (href: any) => buildHref(href, isQ) }), [isQ])
}

export default useQHref
